import { IconButton, Icon } from '@monash/portal-react';
import {
  isArchivable,
  isDeletable,
  isPublishable,
  isSchedulable,
} from '../utils/statuses';
import { SUBMIT_TYPES } from '../constants';
import { useRef } from 'react';
import c from './bulk-actions-buttons.module.scss';

const BulkActionsButtons = ({
  selectedLinks,
  setBulkAction,
  setBulkActionsModalShown,
  bulkActionTriggerRef,
}) => {
  const triggerRefs = useRef({
    [SUBMIT_TYPES.PUBLISH]: null,
    [SUBMIT_TYPES.SCHEDULE]: null,
    [SUBMIT_TYPES.DELETE]: null,
    [SUBMIT_TYPES.ARCHIVE]: null,
  });

  const hasPublishable = selectedLinks.some(isPublishable);

  const hasSchedulable = selectedLinks.some(isSchedulable);

  const hasDeletable = selectedLinks.some(isDeletable);

  const hasArchivable = selectedLinks.some(isArchivable);

  return (
    <div className={c.container}>
      {hasPublishable && (
        <IconButton
          ref={(el) => {
            triggerRefs.current[SUBMIT_TYPES.PUBLISH] = el;
          }}
          icon={Icon.WorldArrow}
          color="var(--canvas-text-color)"
          onClick={() => {
            setBulkAction(SUBMIT_TYPES.PUBLISH);
            bulkActionTriggerRef.current =
              triggerRefs.current[SUBMIT_TYPES.PUBLISH];
            setBulkActionsModalShown(true);
          }}
          aria-label="Bulk Publish"
        />
      )}
      {hasSchedulable && (
        <IconButton
          ref={(el) => {
            triggerRefs.current[SUBMIT_TYPES.SCHEDULE] = el;
          }}
          icon={Icon.CalendarArrow}
          color="var(--canvas-text-color)"
          onClick={() => {
            setBulkAction(SUBMIT_TYPES.SCHEDULE);
            bulkActionTriggerRef.current =
              triggerRefs.current[SUBMIT_TYPES.SCHEDULE];
            setBulkActionsModalShown(true);
          }}
          aria-label="Bulk Schedule"
        />
      )}
      {hasDeletable && (
        <IconButton
          ref={(el) => {
            triggerRefs.current[SUBMIT_TYPES.DELETE] = el;
          }}
          icon={Icon.Trash}
          color="var(--canvas-text-color)"
          onClick={() => {
            setBulkAction(SUBMIT_TYPES.DELETE);
            bulkActionTriggerRef.current =
              triggerRefs.current[SUBMIT_TYPES.DELETE];
            setBulkActionsModalShown(true);
          }}
          aria-label="Bulk Delete"
        />
      )}
      {hasArchivable && (
        <IconButton
          ref={(el) => {
            triggerRefs.current[SUBMIT_TYPES.ARCHIVE] = el;
          }}
          icon={Icon.Box}
          color="var(--canvas-text-color)"
          onClick={() => {
            setBulkAction(SUBMIT_TYPES.ARCHIVE);
            bulkActionTriggerRef.current =
              triggerRefs.current[SUBMIT_TYPES.ARCHIVE];
            setBulkActionsModalShown(true);
          }}
          aria-label="Bulk Archive"
        />
      )}
    </div>
  );
};

export default BulkActionsButtons;
